import React from "react";
import * as styles from "./BVReviewInput.css";
import Textarea from "react-textarea-autosize";
import PropTypes from "prop-types";

export class BVReviewInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            focused: false,
            valid: null
        };
    }

    render() {
        const { focused } = this.state;
        const { onChange, defaultValue } = this.props;
        return (
            <div className={focused ? styles.containerFocus : styles.container}>
                <Textarea
                    defaultValue={defaultValue}
                    className={styles.textareaInput}
                    name="reviewtext"
                    placeholder="Пример: Я купил этот продукт в прошлом месяце и остался очень доволен..."
                    maxLength="10000"
                    minRows={6}
                    onFocus={() =>
                        this.setState({
                            focused: true
                        })
                    }
                    onBlur={() => {
                        this.setState({
                            focused: false
                        });
                    }}
                    onChange={e => {
                        onChange(e.target.value);
                    }}
                />
            </div>
        );
    }
}

BVReviewInput.propTypes = {
    onChange: PropTypes.func.isRequired,
    defaultValue: PropTypes.string
};